<template lang="pug">
.checkboxSelectComponent
  .options
    template(v-for="(option, index) in selection")
      .option
        ui-checkbox-select-option(
          :key="index",
          :option="option",
          :is-selected="option.isSelected"
          :is-disabled="isDisabled",
          @select="onSelect",
          @deselect="onDeselect"
        )
</template>

<script>
import UiCheckboxSelectOption from './UiCheckboxSelectOption.vue'
export default {
  components: {
    UiCheckboxSelectOption
  },
  props: {
    modelValue: {
      type: [Number, Array],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    isDisabled: Boolean,
    allowEmpty: Boolean,
    isMultiple: Boolean
  },
  emits: ['update:modelValue'],
  computed: {
    selection () {
      return this.options.map(option => ({
        id: option.id,
        label: option.label,
        isSelected: this.isMultiple ? this.modelValue?.includes(option.id) : this.modelValue === option.id
      }))
    }
  },
  methods: {
    onSelect (value) {
      let newValue = value
      if (this.isMultiple) {
        newValue = (Array.isArray(this.modelValue) ? [...this.modelValue, value].sort((a, b) => a - b) : [value])
      }
      this.$emit('update:modelValue', newValue)
    },
    onDeselect (value) {
      let newValue = null
      if (this.isMultiple) {
        newValue = this.modelValue.length === 1 ? null : this.modelValue.filter(v => v !== value)
      }
      if (this.allowEmpty || newValue !== null) this.$emit('update:modelValue', newValue)
    }
  }
}
</script>

<style lang="sass" scoped>
.checkboxSelectComponent
  .options
    .option
      margin-top: 4*$u
</style>
